<!-- 表示三级选择的弹框 -->
<template>
  <div class = "threeSelect" v-show = 'showFlag'>
    <div class = "shade"></div>
    <div class = "contents">
      <div class = "choiceThreeSelect">
        <div class = "choiceThreeSelect-top clearfloat full_width">
          <div class = "ct-ThreeSelect full_width">
            <div class = "clearfloat ct-ThreeSelect-header full_width">
              <span class = "flags pull-left">已选择（<label class = "label">{{ choosedInfoId.length }}</label>/{{
                  maxCount
                }}）</span>
              <!-- 输入框的检索内容 -->
              <div class = "wordSearch pull-left">
                <Input prefix = "ios-search"
                       @on-blur = "inputBlurHandle"
                       @on-focus = "searchInfoShowFlag = true"
                       v-model = "keywordContent"
                       placeholder = "请输入搜索内容" style = "width: 100%"
                       clearable/>
                <div class = "searchPopup overflowScroll" v-show = "keywordContent && searchInfoShowFlag">
                  <ul v-show = "searchResultInfoInfo.length > 0">
                    <li v-for = "item in searchResultInfoInfo" :key = "item.id3" @click.stop = "choosedSearchDeatil(item)">
                      <div class = "font1" v-html="item.title3Too" > </div>
                      <div class = "font2">{{ item.title1 }} - {{ item.title2 }}</div>
                    </li>
                  </ul>
                  <ul v-show = "searchResultInfoInfo.length === 0">
                    <li class = "text-center">
                      暂无检索内容
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class = "chooseContent">
              <span
                  v-for = "(item, index) in choosedInfo"
                  @click = "_removeChoosedItem(item.id, index)"
                  :key = "item.id"
                  class = 'span1'
              ><span class = 'span2' :title = 'item.title'>{{ item.title }}</span><i>×</i></span>
            </div>
          </div>
          <div class = "ct-right">
            <div class = "ct-right-close" @click = "_cancel()">取消</div>
            <div class = "ct-right-sure" @click = "_define()">确定</div>
          </div>
        </div>
        <div class = "choiceThreeSelect-bottom">
          <div class = "bottom-left first">
            <ul>
              <li
                  v-for = "(item) in oneSelectInfo"
                  :key = "item.id"
                  @click = "_oneMenuClickHandler(item.id, false)"
                  :class = "[oneTabIndex.indexOf(item.id) !== -1 ? 'active' : '']"
              >
                {{ item.title }}
                <div></div>
              </li>
            </ul>
          </div>
          <div class = "bottom-right">
            <ul>
              <li
                  v-for = "(item) in twoSelectInfo"
                  :key = "item.id"
                  @click = "_twoMenuClickHandler(item.id, false)"
                  :class = "[twoTabIndex.indexOf(item.id) !== -1 ? 'active' : '']"
              >
                <span>{{ item.title }}</span>
              </li>
            </ul>
          </div>
          <div class = "bottom-righttwo">
            <ul>
              <li
                  v-for = "item in threeSelectInfo"
                  :key = "item.id"
                  @click = "_threeMenuClickHandler(item)"
                  :class = "{active: choosedInfoId.join(',').indexOf(item.id) !== -1}"
              >
                <span class = 'points'>{{ item.title }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- 样式部分 -->
<style lang = 'less' scoped>
@import "./index.less";
</style>

<!-- 表示js动作 -->
<script>

// 原数据拍平处理
let targetDelayeringInfo = []
// 导出模块
export default {

  // 名称
  name: 'cu-threeselect',

  // 表示数据
  data: function() {

    return {

      // 表示显示一级select
      oneSelectInfo: [],
      // 表示显示二级select
      twoSelectInfo: [],
      // 表示显示三级select
      threeSelectInfo: [],
      // 表示一级内容选中状态
      oneTabIndex: 0,
      // 表示二级内容选中状态
      twoTabIndex: '',
      // 表示被选中的id
      choosedInfo: [],
      // 表示选中的value
      choosedInfoId: [],
      // 表示关键字内容
      keywordContent: '',
      // 检索内容弹框显隐
      searchInfoShowFlag: true
    }
  },

  // 表示参数
  props: {

    // 表示显示隐藏
    showFlag: {
      type: Boolean,
      default: true
    },

    // 表示传递的总数据
    propinfo: {
      type: Object,
      default: () => {
      }
    },

    // 表示被选中信息
    propChoosedInfo: {
      type: Array,
      default: () => []
    },

    // 表示可以选择的最大个数
    maxCount: {
      type: Number,
      default: 3
    },

    // 表示三级菜单是否添加不限
    threeUnlimit: Boolean
  },

  // 计算属性
  computed: {

    /**
     * @author lihh
     * @description 输入框输入数据后 计算存在的数据
     * */
    searchResultInfo() {
      if ( !this.keywordContent ) return []
      return targetDelayeringInfo.filter(({ title3 }) => title3.indexOf(this.keywordContent) !== - 1)
    },

    searchResultInfoInfo() {
      
      return this.searchResultInfo.map(item => ({
        ...item,
        title3Too:item.title3.split(this.keywordContent).join("<span style = 'color:blue'>" + this.keywordContent + "</span>")
      }))
    },
  },

  // 监听
  watch: {

    // 设置显隐变化
    showFlag: function(val) {

      // 判断是否被打开
      if ( val ) {

        this.keywordContent = ''
        this._initDataSetting()
        // 进行数据扁平化处理
        this.targetDelayeringHandle()
      }
    }
  },

  // 表示方法
  methods: {

    /**
     * @author lihh
     * @description 进行元素拍平化
     * */
    targetDelayeringHandle() {
      targetDelayeringInfo = []
      // 给数据添加标识 分别是title1 title2 title3
      const run = (code, area, level, target = {}) => {
        if ( code.indexOf('_') !== - 1 ) return
        target[`title${ level }`] = area
        target[`id${ level }`] = code
        if ( level === 3 ) {
          targetDelayeringInfo.push(Object.assign({}, target))
        }
      }

      // 递归解析数据
      const resolveData = ({ code: id, area: title }, target, level) => {
        run(id, title, level, target)
        if ( this.propinfo[id] ) {
          this.propinfo[id].forEach(item => resolveData(item, target, item.pid ? 3 : 2))
        }
      }

      // 循环遍历一级分类
      this.propinfo['1'].forEach(item => {
        const targetArr = {}
        resolveData(item, targetArr, 1)
      })
    },

    /**
     * @author lihh
     * @description 表示被选中的检索明细
     * @param id1 表示一级分类
     * @param id2 表示二级分类
     * @param id3 表示三级分类
     * @param title3 表示三级标题
     * */
    choosedSearchDeatil({ id1, id2, id3, title3 }) {

      // 分别选择三级分类  清空输入框
      this._oneMenuClickHandler(id1)
      this._twoMenuClickHandler(id2)
      this._threeMenuClickHandler({ id: id3, title: title3, pid: id2 })
      this.keywordContent = ''
    },

    /**
     * @author lihh
     * @description 输入框光标离开input事件
     * */
    inputBlurHandle() {
      let timer = setTimeout(() => {
        this.searchInfoShowFlag = false
        clearTimeout(timer)
        timer = null
      }, 300)
    },

    /**
     * @author lihh
     * @description 初期化数据
     */
    _initDataSetting: function() {

      // 设置初期值
      this.oneSelectInfo = []
      this.twoSelectInfo = []
      this.threeSelectInfo = []
      this.choosedInfo = []
      this.choosedInfoId = []
      this.oneTabIndex = ''
      this.twoTabIndex = ''

      // 设置一级菜单内容
      let oneItem = this.propinfo['1']
      oneItem.forEach(item => this.oneSelectInfo.push({ id: item.code, title: item.area }))

      // 判断是否需要选中
      if ( this.propChoosedInfo.length === 0 ) return false

      const propinfo = JSON.parse(JSON.stringify(this.propinfo))
      // 针对不限  对原始的菜单做特殊处理
      this.propChoosedInfo.forEach(item => {
        Reflect.ownKeys(propinfo).forEach(item1 => {
          // 判断是否是不限
          if ( item.indexOf('@') === - 1 ) {
            return true
          }
          const id = item.split('@')[0]
          if ( item1 === id ) {
            propinfo[item1].unshift({ area: `${ this.getTitle(id) }(不限)`, code: item })
          }
        })
      })

      // 循环遍历 获取内容 通过三级菜单 获取 二级菜单
      this.propChoosedInfo.forEach(item => {

        Reflect.ownKeys(propinfo).forEach(item1 => {
          propinfo[item1].forEach(item2 => {

            // 判断选中的id 是否相等
            if ( item === item2['code'] ) {

              this.choosedInfo.push({ id: item2['code'], title: item2['area'], pid: item2['pid'] })
              this.choosedInfoId.push(item2['code'])

              // 二级选中id
              this.twoTabIndex += item1 + ','
            }
          })
        })
      })

      // 循环遍历 听过二级菜单获取一级菜单
      this.twoTabIndex.split(',').forEach(item => {

        if ( !item || item === '' ) return true

        Reflect.ownKeys(propinfo).forEach(item1 => {
          propinfo[item1].forEach(item2 => {

            // 判断选中的id 是否相等
            if ( item === item2['code'] ) {

              // 一级菜单选中状态
              this.oneTabIndex += item1 + ','
            }
          })
        })
      })

      // 设置二级菜单选中内容
      this._oneMenuClickHandler(this.oneTabIndex.split(',')[0], true)
      // 设置三级菜单选中状态
      this._twoMenuClickHandler(this.twoTabIndex.split(',')[0],
          this.propChoosedInfo.length <= 0)
    },

    /**
     * @author lihh
     * @description 点击一级菜单筛选二级菜单
     * @param id 表示选中一级id
     * @param index 表示一级菜单下标
     */
    _oneMenuClickHandler: function(id = '', choosedFlag = false) {
      this.threeSelectInfo = []

      // 表示查询数组
      let items = []
      Reflect.ownKeys(this.propinfo).forEach(key => {

        // 判断值是否相等
        if ( id === key ) {

          items = this.propinfo[key]
          return false
        }
      })
      this.twoSelectInfo = []
      items.forEach(item => this.twoSelectInfo.push({ id: item.code, title: item.area }))
      if ( !choosedFlag ) this.oneTabIndex = id
    },

    /**
     * @author lihh
     * @description 点击二级菜单 筛选三级菜单
     * @param id 表示选中一级id
     */
    _twoMenuClickHandler: function(id = '', choosedFlag = false) {

      // 表示查询数组
      let items = []
      Reflect.ownKeys(this.propinfo).forEach(key => {

        // 判断值是否相等
        if ( id === key ) {

          items = this.propinfo[key]
          return false
        }
      })
      this.threeSelectInfo = []
      items.forEach(item => this.threeSelectInfo.push({ id: item.code, title: item.area, pid: item.pid }))
      // 判断三级菜单 是否添加不限
      if ( this.threeUnlimit && !choosedFlag ) {
        this.threeSelectInfo.unshift({ id: `${ id }@-1`, title: '不限' })
      }
      if ( !choosedFlag ) this.twoTabIndex = id
    },

    /**
     * @author lihh
     * @description 表示点击三级菜单 进行选中
     * @param param 表示整行元素
     */
    _threeMenuClickHandler: function(param = {}) {

      // 判断个数
      if ( this.choosedInfoId.length >= this.maxCount ) {

        this.$Message.error(`最多可以选择${ this.maxCount }个`)
        return false
      }

      // 判断id是否已经被添加过
      if ( this.choosedInfoId.includes(param.id) ) {
        this.$Message.error(`该项已经被选择过,请重新选择`)
        return false
      }

      // 判断是否选择不限
      let item = JSON.parse(JSON.stringify(param))
      const { pid } = item
      if ( this.choosedInfoId.join(',').indexOf(pid) !== - 1 ) {
        return
      }
      const id = item.id
      if ( item.id.indexOf('@') !== - 1 ) {
        const pid = id.split('@')[0]
        const title = this.twoSelectInfo.filter(item1 => item1.id === pid)[0]['title']
        item['title'] = title + '(不限)'

        const itemsInfo = JSON.parse(JSON.stringify(this.choosedInfo))
        for ( let i = (itemsInfo.length - 1); i >= 0; i -- ) {
          if ( itemsInfo[i].pid === pid ) {
            this.choosedInfoId.splice(i, 1)
            this.choosedInfo.splice(i, 1)
          }
        }
      }

      // 设置选中内容
      this.choosedInfo.push(item)
      this.choosedInfoId.push(id)
    },

    /**
     * @author lihh
     * @description 点击选中区域进行删除
     * @param id 表示选中id
     * @param index 表示选中的下标
     */
    _removeChoosedItem: function(id = '', index = 0) {

      // 删除元素
      this.choosedInfo.splice(index, 1)
      this.choosedInfoId.splice(index, 1)
    },

    /**
     * @author lihh
     * @description 点击取消按钮
     */
    _cancel: function() {

      this.$emit('_threeSelectSwitch', '0')
    },

    /**
     * @author lihh
     * @description 根据id 获取对应的名称
     */
    getTitle(id = '') {

      let title = ''
      Object.keys(this.propinfo).forEach(item => {
        this.propinfo[item].forEach(item1 => {
          if ( item1.code === id ) {
            title = item1.area
            return
          }
        })
      })
      return title
    },

    /**
     * @author lihh
     * @description 点击确定按钮
     */
    _define: function() {

      // 判断是否选择内容
      if ( this.choosedInfo.length === 0 ) {

        this.$Message.error('请选择行业领域')
        return false
      }
      this.$emit('_threeSelectSwitch', '0', this.choosedInfo)
    }

  },

  // 组件销毁前钩子
  beforeDestroy() {
    targetDelayeringInfo = []
  }
}
</script>



// WEBPACK FOOTER //
// src/packages/ThreeSelect/CuThreeSelect/Cu-ThreeSelect.vue